import React, { useState } from "react";
import { Link } from "react-router-dom";

const Nav = (props) => {
  const { logo, nombre, nombreUrl } = props;

  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  return (
    <header>
      <nav className="container navbar navbar-expand-lg navbar-light ppr-nav">
        <div className="navbar-logos">
          <img
            src={"/img/logos/logo_nombre_ppr.svg"}
            alt="Presupuesto Participatico Raíz"
            className="img-fluid navbar-logo mr-4 d-none d-sm-inline"
          />
          <img
            src={"/img/logos/logo_ppr.svg"}
            alt="Presupuesto Participatico Raíz"
            className="img-fluid navbar-logo mr-4 d-block d-sm-none"
          />
        </div>
        <div className=" mr-auto navbar-logos">
          <Link to={`/municipio/${nombreUrl}`}>
            <img
              className="img-fluid navbar-logo mr-2"
              src={`/img/logos/${logo}`}
              alt={nombre}
            />
          </Link>
        </div>
        <button
          className="custom-toggler navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbartoggle"
          aria-controls="navbartoggle"
          aria-expanded={!isNavCollapsed ? true : false}
          aria-label="Toggle de navegación"
          onClick={handleNavCollapse}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`}
          id="navbartoggle"
        >
          <Link
            className="nav-link ml-auto"
            to={`/municipio/${nombreUrl}/info`}
          >
            MÁS INFORMACIÓN
          </Link>

          <Link className="nav-link" to={`/municipio/${nombreUrl}/contacto`}>
            CONTACTO
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Nav;
